import axios from 'axios';

export const qd = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/qd` });
export const po = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/po` });

[qd, po].forEach((client) => {
  client.interceptors.request.use((config) => {
    const token = localStorage.getItem('qd_token');
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  });
  client.interceptors.response.use(
    (r) => r,
    (err) => {
      if (err.response?.status === 401 && !err.config.url.includes('/auth/login')) {
        localStorage.removeItem('qd_token');
        window.location.href = '/quote/login';
      }
      return Promise.reject(err);
    }
  );
});

export const apiError = (e) => {
  const d = e.response?.data?.detail;
  if (typeof d === 'string') return d;
  if (Array.isArray(d)) return d.map((x) => x.msg || JSON.stringify(x)).join(' ');
  return e.message || 'Error';
};

export const money = (n) => `€${Number(n || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const ENTITY_BY_COUNTRY = { LT: 'uab', LV: 'sia', EE: 'e2' };
export const STATUS_COLORS = {
  draft: 'bg-slate-100 text-slate-600',
  sent: 'bg-blue-50 text-blue-700',
  accepted: 'bg-emerald-50 text-emerald-700',
  expired: 'bg-red-50 text-red-600',
};

const OG_LOGO_NAVY = 'https://customer-assets-lqy194kg.emergentagent.net/job_96c739ff-ac3f-4d8c-8dce-b0efed541c1d/artifacts/iwtv5zw5_0G_Baltics_logo_navy.png';
const E2_LOGO = 'https://customer-assets-lqy194kg.emergentagent.net/job_96c739ff-ac3f-4d8c-8dce-b0efed541c1d/artifacts/cypvkyvr_e2_SSa-R02b_Mil.png';

export const EntityLogo = ({ entity, className = 'h-10' }) => {
  if (!entity) return null;
  if (entity.logo === 'e2') {
    return <img src={E2_LOGO} alt={entity.name} className={className} />;
  }
  return <img src={OG_LOGO_NAVY} alt={entity.name} className={className} />;
};
